export class Payer {
  public pais: string;
  public ciudad: string;
  public estado: string;
  public nombres: string;
  public apellidos: string;
  public direccion: string;
  public correoElectronico: string;
}
